import { UPLOAD_MESSAGES, UPLOAD_POLICY, checkFile } from '@mapeamento/shared';

export interface AddResult {
  /** Mensagens de arquivos recusados (tipo, tamanho ou quantidade). */
  rejected: string[];
}

/** Arquivos selecionados pelo usuário, mantidos em memória até o envio. */
export class AttachmentBag {
  private files: File[] = [];

  get list(): readonly File[] {
    return this.files;
  }

  add(incoming: Iterable<File>): AddResult {
    const rejected: string[] = [];
    for (const file of incoming) {
      const problem = checkFile(file);
      if (problem) {
        rejected.push(`${file.name}: ${UPLOAD_MESSAGES[problem]}`);
      } else if (this.files.length >= UPLOAD_POLICY.maxFiles) {
        rejected.push(`${file.name}: ${UPLOAD_MESSAGES.tooMany}`);
      } else {
        this.files.push(file);
      }
    }
    return { rejected };
  }

  remove(index: number): void {
    this.files.splice(index, 1);
  }

  clear(): void {
    this.files = [];
  }
}
